'use client';

import { Share2 } from 'lucide-react';

import { useShareDialog } from '../../../../sharing/useShareDialog';

interface Props {
  /** Absolute, pre-built share URL (from `PostViewModel.shareUrl`). */
  url: string;
  /** Native-share + dialog title — the post title. */
  title?: string;
}

/**
 * Footer share affordance — opens the app-wide standard share dialog (Web Share
 * API with a copy-link fallback) via {@link useShareDialog}. Sits beside like +
 * comment. The URL is pre-built on the view model (`bioUrl(ctx, { share: true })`),
 * so this island never hand-assembles a link or touches `navigator.share`.
 */
export function PostShareButton({ url, title }: Props) {
  const { openShare } = useShareDialog();
  return (
    <button
      type="button"
      onClick={() => openShare({ url, title })}
      aria-label="Share"
      className="flex items-center gap-1.5 text-[12px] opacity-80 transition hover:opacity-100"
    >
      <Share2 className="h-[18px] w-[18px]" aria-hidden />
    </button>
  );
}
